module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc35-8d095a3cea6b3a88c28321b43b0616eb.jpg";